
//Node Modules
import { HTMLReactParserOptions, DomElement } from 'html-react-parser';

//Utils
import factories from './factories'
import * as conditions from './conditions'

interface Condition {
  (node:DomElement): boolean
}

interface Factory {
  (node:DomElement, params:any, options:any): JSX.Element | JSX.Element[] | void
}

interface Parser {
  condition: Condition
  create: Factory
}

const parsers:Parser[] = [
  {
    // Document Image
    condition: conditions.imgElement,
    create: factories.DocumentImage
  },
  {
    // Empty div
    condition: (node:DomElement) => conditions.htmlElement(node) || conditions.bodyElement(node) || conditions.headElement(node),
    create: factories.div
  },
  {
    // Carousel
    condition: conditions.carouselAttrib,
    create: factories.Carousel
  },
  {
    // Content Link
    condition: conditions.docsetIdVersionAttribs,
    create: factories.ContentLink
  },
  //Anchor Link
  { 
    condition: conditions.anchorLink,
    create: factories.AnchorLink
  },
  {
    // Title
    condition: conditions.titleElement,
    create: factories.Title
  },
  {
    // Stylesheet
    condition: (node:DomElement) => conditions.hasAttrib(node, 'data-xis-css-ref'),
    create: factories.Stylesheet
  },
  {
    // Content Feature Flag
    condition: (node:DomElement) => conditions.hasAttrib(node, 'data-id-flag'),
    create: factories.ContentFlag
  },
  {
    // Clear Text
    condition: (node:DomElement) => conditions.hasName(node, 'table') || conditions.hasName(node, 'tr') || conditions.hasName(node, 'tbody'),
    create: factories.clearText
  },
  {
    // CAS Format
    condition: conditions.xisCasFormatAttribs,
    create: factories.XisCasFormat
  },
  {
    // Copy To Clipboard
    condition: (node:DomElement) => conditions.hasClass(node, 'xis-copyToClipboardBtn'),
    create: factories.CopyToClipboard
  },
  {
    // CAS Language Selector
    condition: (node:DomElement) => conditions.hasClass(node, "xisCas-languageButtons"),
    create: factories.CASLanguage
  },
  {
    // CAS Syntax section
    condition: (node:DomElement) => conditions.hasAttribValueLike(node, 'id', /\b(SAS|Lua|R|Python)\b-syntax/),
    create: factories.CASSyntax
  },
  {
    // Collapsible
    condition: (node:DomElement) => conditions.hasAttrib(node, "data-collapse-container"),
    create: factories.Collapsible
  },
  {
  //ExpandCollapseAll
  condition: (node:DomElement) => conditions.hasAttrib(node, "data-expandcollapse"),
  create: factories.ExpandCollapseAll
  },
  {
    // TabBar
    condition: (node:DomElement) => conditions.hasClass(node, "xis-tabBar"),
    create: factories.TabBar
  },
  {
    // Glossary
    condition: (node:DomElement) => conditions.hasAttrib(node, 'data-gloss-item'),
    create: factories.Glossary
  },
  {
    // Meta
    condition: (node:DomElement) => conditions.hasName(node, 'meta'),
    create: factories.Meta
  },
  {
    // Comment
    condition: (node:DomElement) => conditions.hasType(node, 'comment'),
    create: factories.Comment
  }
]

const parse = (params:any):HTMLReactParserOptions => {
  const options:HTMLReactParserOptions = {
    replace: (node:DomElement) => {
      const parser = parsers.filter(({ condition }) => condition(node))[0]

      if (parser) {
        return parser.create(node, params, options)
      }
    }
  }

  return options
}

export default parse